import { RootState } from '@/store/types';
import { Module, MutationTree, ActionTree, GetterTree, ActionContext } from 'vuex';
import _ from 'lodash';

const namespaced: boolean = true;

export interface TableauVaccinationsState {
	filter: string;
	descSort: boolean;
	currentPage: number;
	nbLignes: string;
}

export const state: TableauVaccinationsState = {
	filter: '',
	descSort: false,
	currentPage: 1,
	nbLignes: ''
};

export const mutations: MutationTree<TableauVaccinationsState> = {
	setFilter(state: TableauVaccinationsState, filter: string) {
		state.filter = filter;
	},

	setDescSort(state: TableauVaccinationsState, descSort: boolean) {
		state.descSort = descSort;
	},

	setCurrentPage(state: TableauVaccinationsState, currentPage: number) {
		state.currentPage = currentPage;
	},

	setNbLignes(state: TableauVaccinationsState, nbLignes: string) {
		state.nbLignes = nbLignes;
	},

	cleanRechercheTableau(state: TableauVaccinationsState) {
		state.filter = '';
		state.descSort = false;
		state.currentPage = 1;
		state.nbLignes = '';
	}
};

export const actions: ActionTree<TableauVaccinationsState, RootState> = {
	setFilter(context: ActionContext<TableauVaccinationsState, RootState>, filter: string) {
		context.commit('setFilter', filter);
	},

	setDescSort(context: ActionContext<TableauVaccinationsState, RootState>, descSort: boolean) {
		context.commit('setDescSort', descSort);
	},

	setCurrentPage(context: ActionContext<TableauVaccinationsState, RootState>, currentPage: number) {
		context.commit('setCurrentPage', currentPage);
	},

	setNbLignes(context: ActionContext<TableauVaccinationsState, RootState>, nbLignes: string) {
		context.commit('setNbLignes', nbLignes);
	},

	cleanRechercheTableau(context: ActionContext<TableauVaccinationsState, RootState>) {
		context.commit('cleanRechercheTableau');
	}
};

export const getters: GetterTree<TableauVaccinationsState, RootState> = {

	getFilter(state: TableauVaccinationsState): string {
		return state.filter;
	},

	getDescSort(state: TableauVaccinationsState): boolean {
		return state.descSort;
	},

	getCurrentPage(state: TableauVaccinationsState): number {
		return state.currentPage;
	},

	getNbLignes(state: TableauVaccinationsState): string {
		return state.nbLignes;
	}

};

export const tableauVaccinations: Module<TableauVaccinationsState, RootState> = {
	namespaced,
	state,
	actions,
	getters,
	mutations
};
